import React from 'react';

import Button, { ButtonStyleType } from '../common/Button/Button';
import ActionButtonsWrapper from '../common/ModalWindow/ActionButtonsWrapper/ActionButtonsWrapper';
import AgConfirmationModal from '../common/ModalWindow/AgConfirmationModal';
import AgModalWindow from '../common/ModalWindow/AgModalWindow';
import { ModalWindowItemInternal } from './ModalWindowApiContext';

interface IModalWindowResolverProps {
  modalWindowItem: ModalWindowItemInternal;
  close: (id: UUID) => void;
}

export default function ModalWindowResolver({
  modalWindowItem,
  close,
}: IModalWindowResolverProps) {
  const modalType = modalWindowItem?.modalType ?? 'default';

  const onClickCloseButton = (id: UUID, callback?: Function) => {
    if (typeof callback === 'function') {
      callback();
    }

    close(id);
  };

  const onClickConfirmButton = (id: UUID, callback?: Function) => {
    if (typeof callback === 'function') {
      callback();
    }
  };

  if (modalType === 'default') {
    return (
      <AgModalWindow
        title={modalWindowItem.title}
        isOpen={true}
        onClose={() => {
          modalWindowItem?.onCloseCallback?.();
          onClickCloseButton(modalWindowItem.id);
        }}
      >
        <modalWindowItem.ModalContent />

        {(modalWindowItem?.onCancelButtonParams || modalWindowItem?.onConfirmButtonParams) && (
          <ActionButtonsWrapper
            leftButton={modalWindowItem?.onCancelButtonParams && (
              <Button
                buttonStyleType={ButtonStyleType.SECONDARY}
                onClick={() => {
                  onClickCloseButton(modalWindowItem.id, modalWindowItem?.onCancelButtonParams?.callback);
                }}
                disabled={modalWindowItem?.onCancelButtonParams?.isDisabled}
              >
                {modalWindowItem?.onCancelButtonParams?.text ?? 'Cancel'}
              </Button>
            )}
            rightButton={modalWindowItem?.onConfirmButtonParams && (
              <Button
                buttonStyleType={ButtonStyleType.PRIMARY}
                onClick={() => {
                  onClickConfirmButton(modalWindowItem.id, modalWindowItem?.onConfirmButtonParams?.callback);
                }}
                disabled={modalWindowItem?.onConfirmButtonParams?.isDisabled}
              >
                {modalWindowItem?.onConfirmButtonParams?.text ?? 'Save'}
              </Button>
            )}
          />
        )}
      </AgModalWindow>
    );
  }

  if (modalType === 'confirmation') {
    return (
      <AgConfirmationModal
        onConfirm={() => onClickConfirmButton(modalWindowItem.id, modalWindowItem?.onConfirmButtonParams?.callback)}
        onClose={() => onClickCloseButton(modalWindowItem.id, modalWindowItem?.onCancelButtonParams?.callback)}
        isOpen={true}
        title={modalWindowItem.title}
        closeText={modalWindowItem?.onCancelButtonParams?.text ?? 'Cancel'}
        confirmText={modalWindowItem?.onConfirmButtonParams?.text ?? 'Save'}
      >
        <modalWindowItem.ModalContent />
      </AgConfirmationModal>
    );
  }

  return null;
}
